module.exports = __webpack_public_path__ + "media/images/portugal_center/portugal-b40a29d9869884a08528b816199613b0.jpg";